<template>
	<div class="select-day-of-month flex flex-wrap sm:flex-no-wrap">
		<div :class="['sm:w-1/2 w-full', { 'mb-3 sm:mb-0 sm:mr-3': $i18n.locale !== 'vi' }]">
			<select-ordinarily filterable name="ordinarily" class="w-full" v-validate="required" v-model="localBySetPosValue" :data-vv-as="ordinarilyLabel" :placeholder="ordinarilyPlaceholder" />
			<span class="text-danger text-sm break-normal" v-show="errors.has('ordinarily')">{{ errors.first("ordinarily") }}</span>
		</div>
		<div :class="['sm:w-1/2 w-full', { 'order-first mb-3 sm:mb-0 sm:mr-3': $i18n.locale === 'vi' }]">
			<select-day-option name="dayoftheweek" filterable class="w-full" v-validate="required ? 'required' : ''" v-model="localByDayValue" :data-vv-as="dayLabel" :placeholder="dayPlaceholder" />
			<span class="text-danger text-sm break-normal" v-show="errors.has('dayoftheweek')">{{ errors.first("dayoftheweek") }}</span>
		</div>
	</div>
</template>

<script>
import SelectDayOption from "./SelectDayOption";
import SelectOrdinarily from "./SelectOrdinarily";

export default {
	name: "SelectOrdinarilyDay",
	inject: ["parentValidator"],
	components: {
		SelectDayOption,
		SelectOrdinarily
	},
	props: {
		value: {
			type: Object,
			required: true
		},
		dayLabel: {
			type: String,
			default: "Day"
		},
		ordinarilyLabel: {
			type: String,
			default: "Ordinarily"
		},
		dayPlaceholder: String,
		ordinarilyPlaceholder: String,
		required: {
			type: String,
			default: ""
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localBySetPosValue: {
			get() {
				return this.localValue.bysetpos;
			},
			set(val) {
				this.localValue = {
					...this.localValue,
					bysetpos: val
				};
			}
		},
		localByDayValue: {
			get() {
				return this.localValue.byday;
			},
			set(val) {
				this.localValue = {
					...this.localValue,
					byday: val
				};
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>
